import { render, staticRenderFns } from "./PersonAccounts.vue?vue&type=template&id=b213701a&scoped=true&"
import script from "./PersonAccounts.vue?vue&type=script&lang=js&"
export * from "./PersonAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b213701a",
  null
  
)

export default component.exports